/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, shape, string, bool,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Dialog from '@material-ui/core/Dialog';
import ReactMarkdown from 'react-markdown';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
    root: {
        marginBottom: '40px',
        padding: '20px 0',
        width: '100%',
        textAlign: 'center',
        background: theme.palette.colorNeutral40,
        borderRadius: '2px',
    },
    rootInline: {
        fontSize: '12px',
    },
    deliveryMessage: {
        marginBottom: '4px',
        fontSize: '18px',
        color: theme.palette.colorNeutral80,
    },
    seeDetails: {
        display: 'inline-block',
        color: theme.palette.colorPrimary,
        cursor: 'pointer',
    },
    seeDetailsInline: {
        display: 'inline-block',
        fontSize: '14px',
        color: theme.palette.colorPrimary,
        cursor: 'pointer',
    },
    dialogeHeader: {
        position: 'sticky',
        top: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        background: theme.palette.white,
    },
    dialogeCloseAction: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '10px',
        textAlign: 'right',
        cursor: 'pointer',
        '&> svg': {
            margin: '-2px 0 0 6px',
        },
    },
});

class GraphqlDeliveryMethodUI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggled: false,
        };
    }

    handleOpen = () => {
        this.setState({ toggled: true });
    };

    handleClose = () => {
        this.setState({ toggled: false });
    };

    render() {
        const {
            classes,
            deliveryMethodData,
            inline,
        } = this.props;
        if (!deliveryMethodData) return null;
        const { copy = '', popup_copy = '' } = deliveryMethodData;
        const { toggled } = this.state;

        // @intention: renders fpt gpt messaging inline
        // @prop: `inline={true}` renders inline layout
        if (inline) {
            return (
                <div className={classes.rootInline}>
                    {copy}{' '}
                    <div
                        className={classes.seeDetailsInline}
                        onKeyDown={() => {}}
                        tabIndex={-1}
                        role="button"
                        onClick={() => this.handleOpen()}
                    >
                        See Details
                    </div>
                    <Dialog open={toggled}>
                        <div className={classes.dialogeHeader}>
                            <span
                                className={classes.dialogeCloseAction}
                                onKeyDown={() => {}}
                                tabIndex={-1}
                                role="button"
                                onClick={() => this.handleClose()}
                            >
                                Close <CloseIcon />
                            </span>
                        </div>
                        <ReactMarkdown
                            source={popup_copy}
                            escapeHtml={false}
                        />
                    </Dialog>
                </div>
            );
        }

        // @intention: renders fpt gpt messaging in a block with grey background
        // @prop: Omit `inline` prop. (Inline Proptype defaults to false.)
        return (
            <div className={classes.root}>
                <div className={classes.deliveryMessage}>{copy}</div>
                <div>
                    <div
                        className={classes.seeDetails}
                        onKeyDown={() => {}}
                        tabIndex={-1}
                        role="button"
                        onClick={() => this.handleOpen()}
                    >
                        See Details
                    </div>
                </div>
                <Dialog open={toggled}>
                    <div className={classes.dialogeHeader}>
                        <span
                            className={classes.dialogeCloseAction}
                            onKeyDown={() => {}}
                            tabIndex={-1}
                            role="button"
                            onClick={() => this.handleClose()}
                        >
                            Close <CloseIcon />
                        </span>
                    </div>
                    <ReactMarkdown
                        source={popup_copy}
                        escapeHtml={false}
                    />
                </Dialog>
            </div>
        );
    }
}

GraphqlDeliveryMethodUI.propTypes = {
    classes: object.isRequired,
    deliveryMethodData: shape({
        copy: string.isRequired,
        popup_copy: string.isRequired,
    }).isRequired,
    inline: bool,
};

GraphqlDeliveryMethodUI.defaultProps = {
    inline: false,
};

export default withStyles(styles)(GraphqlDeliveryMethodUI);
